/* DSL Network status — toon offline-banner indien navigator.onLine === false */
(function(){
  function update(){
    if (navigator.onLine) {
      document.documentElement.classList.remove("dsl-offline");
      var b = document.querySelector(".dsl-offline-banner");
      if (b) b.remove();
    } else {
      document.documentElement.classList.add("dsl-offline");
      if (!document.querySelector(".dsl-offline-banner")) {
        var b = document.createElement("div");
        b.className = "dsl-offline-banner";
        b.setAttribute("role","status");
        b.textContent = "Geen verbinding — bekijk de offline-pagina.";
        document.body.appendChild(b);
      }
    }
  }
  window.addEventListener("online", update);
  window.addEventListener("offline", update);
  update();
})();